module.exports = __webpack_public_path__ + "img/deliveroo.041320c1.svg";